import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faEye, faEyeSlash, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import ConfirmModal from "../../../shared/components/ConfirmModal";
import MensajeForm from "./components/MensajeForm";
import { API_MENSAJES } from "../../../shared/services/mensajes";
import { fetchRecambistasMessages } from "../../../../../../redux/features/dashboard";

export default function MensajesRecambistas() {
    const dispatch = useDispatch();
    const [messageId, setMessageId] = useState(null);
    const [currentMessage, setCurrentMessage] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [isNew, setIsNew] = useState(false);
    const [isForDelete, setIsForDelete] = useState(false);
   
    const messages = useSelector(state => {
        return state.dashboard.user.mensajes
    });

    const handleEdit = (message) => {
        setCurrentMessage(message);
        setIsEdit(true);
    }

    const handleCancel = (action) => { 
        if(action === 'edit') {
            setIsEdit(false);
            setCurrentMessage(null);
        } else {
           setIsNew(false);
           setCurrentMessage(null);
        }
    }

    const newElement = () => {
        setIsEdit(false); 
        setIsNew(true);
    }

    const handleActionDone = () => {
        dispatch(fetchRecambistasMessages());
        setIsNew(false);
        setIsEdit(false);
    }

    const handleDeleteElement = async(messageId) => {
        dispatch({type: 'loading/set', payload: true});
        const response = await API_MENSAJES.deleteMensaje(messageId);
        setCurrentMessage(null);

        if(response && response.success) {
            dispatch({type: 'loading/set', payload: false});
            toast.success(response.message);
            dispatch(fetchRecambistasMessages());
        }
    }

    const handleDelete = (id) => { 
        setMessageId(id);
        setIsForDelete(true); 
    }

    const handleConfirmDelete = (confirm) => {
        if(confirm) {
            handleDeleteElement(messageId)
        } else setIsForDelete(false);
    }

    const handleStatus = async(msg, visible) => {
        dispatch({type: 'loading/set', payload: true});
        const response = await API_MENSAJES.enableDisableMensaje({id: msg, visible: visible});
        setCurrentMessage(null);

        if(response && response.success) {
            dispatch({type: 'loading/set', payload: false});
            toast.success(response.message);
            dispatch(fetchRecambistasMessages());
        }
    }

    return (
        <div className="w-100 d-flex flex-column align-items-start"> 
            <div className="w-100 d-flex flex-wrap flex-md-nowrap justify-content-center">
                <div className="col-12 col-md-8 d-flex flex-column align-items-end order-1 order-md-0">
                    <button type="button" className="btn btn-add mb-4" onClick={() => newElement()}>
                        <span className="add">
                            <FontAwesomeIcon icon={faPlus} size="1x" className="action" color="#215732" />
                        </span>
                        Nuevo
                    </button>

                    <div className="w-100 table-responsive">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Título</th>
                                    <th>Descripción</th>
                                    <th className="text-center">tipo</th>
                                    <th className="text-center">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                { messages?.map((msg, i) => {
                                    return (
                                        <tr key={'valor-' + msg.id}>
                                            <td>{msg.titulo}</td>
                                            <td>{msg.descripcion.length > 50 ? msg.descripcion.substring(0, 25) : msg.descripcion}</td>
                                            <td className="text-center">
                                                <p className={
                                                    msg.tipo === 'info' ? 'text-info'
                                                    : msg.tipo === 'aviso' ? 'text-warning'
                                                    : 'text-danger'
                                                }><b className="text-uppercase">{msg.tipo}</b></p>
                                            </td>
                                            <td className="text-center" width="15%">
                                                <span title="Editar" style={{cursor: 'pointer'}} className="me-3">
                                                    <FontAwesomeIcon icon={faPen} size="1x" className="action" color="#215732" onClick={() => handleEdit(msg)} />
                                                </span>
                                                { msg.visible ?
                                                    <span title="Deshabilitar" style={{cursor: 'pointer'}} className="me-3">
                                                        <FontAwesomeIcon icon={faEyeSlash} size="1x" className="action" color="#dc3545" onClick={() => handleStatus(msg.id, false)} />
                                                    </span>
                                                  :
                                                  <span title="Habilitar" style={{cursor: 'pointer'}} className="me-3">
                                                    <FontAwesomeIcon icon={faEye} size="1x" className="action" color="#215732" onClick={() => handleStatus(msg.id, true)} />
                                                    </span>
                                                }
                                                <span title="Eliminar" style={{cursor: 'pointer'}}>
                                                    <FontAwesomeIcon icon={faTrash} size="1x" className="action" color="#dc3545" onClick={() => handleDelete(msg.id)} />
                                                </span>
                                            </td>
                                        </tr>
                                    )
                                })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                { (isEdit || isNew) &&
                <div className="col-12 col-md-4 d-flex flex-column align-items-end ps-0 ps-md-5  order-0 order-md-1">                
                    <div className="w-100 d-flex flex-column">
                        <MensajeForm 
                            msg={currentMessage}
                            isEdit={isEdit}
                            onCancel={handleCancel}
                            onActionDone={handleActionDone}
                        />
                    </div>
                </div>
                }
            </div>

            { isForDelete && 
                <ConfirmModal 
                    onConfirmAction={handleConfirmDelete} 
                    title={'Eliminar'} 
                    description={'Estás seguro de eliminar?'}
                    state={isForDelete}>
                </ConfirmModal>
            }
        </div>
    )
    
}